import PaymentRequestActions, { paymentRequestActionTypes } from '@Actions/paymentRequestActions';
import TrackerActions from '@Actions/trackerActions';
import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import PaymentRequestServices from '@Services/paymentRequestServices';

/**
 * @param action
 */
function* _getPaymentRequest(action) {
  try {
    yield put(PaymentRequestActions.getPaymentRequestLoading(true));
    const paymentOutgoing = yield PaymentRequestServices.getPaymentRequest(action?.page, action?.limit, action?.tenantId);
    yield put(PaymentRequestActions.getPaymentRequestSuccess(paymentOutgoing));
    yield put(PaymentRequestActions.getPaymentRequestLoading(false));
  } catch (error) {
    yield put(PaymentRequestActions.getPaymentRequestLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentRequestActionTypes.GET_PAYMENT_REQUEST.ERROR, error));
  }
}

/**
 *
 */
function* getPaymentRequest() {
  yield takeEvery(paymentRequestActionTypes.GET_PAYMENT_REQUEST.REQUEST, _getPaymentRequest);
}

/**
 * @param action
 */
function* _createPaymentRequest(action) {
  try {
    yield put(PaymentRequestActions.createPaymentRequestLoading(true));
    const payment = yield PaymentRequestServices.createPaymentRequest(action.payload);
    if (payment.success) {
      yield put(TrackerActions.trackAction(paymentRequestActionTypes.CREATE_PAYMENT_REQUEST.SUCCESS, payment.data));
      notification.open({
        type: 'success',
        message: 'Payment Request Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(payment.payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentRequestActions.createPaymentRequestLoading(false));
  } catch (error) {
    yield put(PaymentRequestActions.createPaymentRequestLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentRequestActionTypes.CREATE_PAYMENT_REQUEST.ERROR, error));
  }
}

/**
 *
 */
function* createPaymentRequest() {
  yield takeLatest(paymentRequestActionTypes.CREATE_PAYMENT_REQUEST.REQUEST, _createPaymentRequest);
}

/**
 * @param action
 */
function* _updatePaymentRequest(action) {
  try {
    yield put(PaymentRequestActions.updatePaymentRequestLoading(true));
    const payment = yield PaymentRequestServices.updatePaymentRequest(action.payload);
    if (payment.success) {
      yield put(TrackerActions.trackAction(paymentRequestActionTypes.UPDATE_PAYMENTS_REQUEST.SUCCESS, payment.data));
      notification.open({
        type: 'success',
        message: 'Payment Request Successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(payment.payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentRequestActions.updatePaymentRequestLoading(false));
  } catch (error) {
    yield put(PaymentRequestActions.updatePaymentRequestLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentRequestActionTypes.UPDATE_PAYMENTS_REQUEST.ERROR, error));
  }
}

/**
 *
 */
function* updatePaymentRequest() {
  yield takeLatest(paymentRequestActionTypes.UPDATE_PAYMENTS_REQUEST.REQUEST, _updatePaymentRequest);
}

/**
 *
 */
export default function* paymentSaga() {
  yield all([
    getPaymentRequest(),
    createPaymentRequest(),
    updatePaymentRequest(),
  ]);
}
